import {inject, Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { ChatHelpRequest, ChatHelpResponse } from "../modules/chat-commands/models/chat-commands.model";
import {AiPunctuateRequestModel} from "../models/ai-request-model";
import {ChatbotService} from "../modules/chat-commands/services/chatbot.service";

@Injectable({
    providedIn: "root",
})
export class AiInstructionService {
    apiServerUrl = `${environment.aiServerUrl2}/speech_to_text2_models_ins`;
    private apiServerPunctuateUrl = `${environment.aiServerUrl2}/punctuate`;
    apiServerUrlForTextPunch = `${environment.aiServerUrlForTranscription}/transcribe_meeting`;
    apiBaseUrl = `${environment.apiBaseUrl}`;
    helpBotBaseUrl = `${environment.aiHelpBotUrl}`;

    chatbotService = inject(ChatbotService);

    constructor(private http: HttpClient) {}

    detectAiInstruction(data: any, accountId: string): Observable<any> {
        data.append("account_id", accountId);
        return this.http.post(this.apiServerUrl, data
        //     // use when using ins in localHost otherwise comment out
        //     , {
        //     headers: {
        //         secretKey: environment.aiServerSecretKeyForLocal
        //     }
        // }
        ).pipe(
            catchError((error) => {
                return throwError(()=>error);
            }),
        );
    }

    createTaskFromMeetingAnalysis(data: any ): Observable<any> {
        return this.http.post(this.apiServerUrl, data
            //     // use when using ins in localHost otherwise comment out
            // , {
            //     headers: {
            //         secretKey: environment.aiServerSecretKeyForLocal
            //     }
            // }
        ).pipe(
            catchError((error) => {
                return throwError(() =>error);
            }),
        );
    }

    transcribeMeeting(audioMultiPartData: any): Observable<any> {
        return this.http.post(this.apiServerUrlForTextPunch, audioMultiPartData).pipe(
            catchError((error) => {
                return throwError(()=>error);
            }),
        );
    }

    //chatbot/v1/search/query"
    helpBotQuery(data: ChatHelpRequest, accountIds: string): Observable<ChatHelpResponse> {
        const sessionId = this.chatbotService.currentSessionId;
        const requestBody = {
            ...data,
            account_id: accountIds,
            session_id: sessionId,
            device: 'web',
        };
        return this.http
            .post<ChatHelpResponse>(`${this.helpBotBaseUrl}info_help`, requestBody, {
                headers: {
                    accountIds: accountIds,
                },
            })
            .pipe(
                catchError((error) => {
                    return throwError(()=>error);
                }),
            );
    }

    //API to punctuate the message
    punctuateVoiceMessage(message: string){
        let request = new AiPunctuateRequestModel();
        request.text = message;
        return this.http.post<any>(this.apiServerPunctuateUrl, request).pipe(
            catchError((error) => {
                return throwError(()=>error);
            }),
        );
    }
}
